import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5rtbg48cb5: FaireBrandEntity = {
  token: "b_5rtbg48cb5",
  type: "brand",
  name: "Tub Works LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/37d8dc1cc6e99c7dc4ec7c9e0a12e3d1f1880f1cb8babdc204ec108dfbfd42fd.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/142b6429aef91798228d7e664c7397e86cb80ec3da1434eb983cda8ca6fb5544.webp",
  logoUrl:
    "https://cdn.faire.com/fastly/37d8dc1cc6e99c7dc4ec7c9e0a12e3d1f1880f1cb8babdc204ec108dfbfd42fd.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/142b6429aef91798228d7e664c7397e86cb80ec3da1434eb983cda8ca6fb5544.webp",
  location: "Dover, DE, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 18,
  isTopShop: true,
  isInsider: true,
  description:
    "Tub Works is a fast growing kids bath brand that focuses on making bath time fun.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:35.197Z",
    importedBy: "entity-db-cli",
  },
};
